import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';

export interface SecretReference {
    entityType: 'workflow' | 'tool';
    entityId: string;
    entityName: string;
    nodeId: string;
    nodeName: string;
    nodeType: string;
    parameterPath: string;
    versionId?: string;
}

export interface SecretWithUsage {
    id: string;
    key: string;
    agentId: string;
    description?: string;
    referenceCount: number;
    references: SecretReference[];
    createdAt: string;
    updatedAt: string;
}

interface SecretsResponse {
    data: SecretWithUsage[];
}

interface UseSecretsParams {
    agentId: string;
    enabled?: boolean;
}

interface UseSecretsResult {
    data: SecretWithUsage[];
    isLoading: boolean;
    error?: Error;
    refetch: () => void;
}

/**
 * Hook to list all secrets for a specific agent with usage information
 * Fetches from the API to include reference counts and details
 */
export const useSecrets = ({ agentId, enabled = true }: UseSecretsParams): UseSecretsResult => {
    const pathname = `/secrets?agentId=${encodeURIComponent(agentId)}`;

    const { data, isLoading, error, refetch } = useHttpQuery<SecretsResponse>({
        pathname,
        method: 'GET',
        key: ['secrets', agentId],
        queryOptions: {
            enabled,
            staleTime: 0,
            cacheTime: 0,
        },
    });

    return {
        data: data?.data || [],
        isLoading,
        error: error || undefined,
        refetch,
    };
};

export default useSecrets;
